
/*
 * --------------------------------------------------------------
 * 					CUBE DIRECTIVES
 * --------------------------------------------------------------
 * */

function chekboxLayout($timeout) {
	return {
		restrict : 'A',
		template : '',
		controller : function($scope, $element) {
			
			$(window).on('load resize', function() {
				var $windowWidth = $(window).width();
				if ($windowWidth >= 768) {
					$('.checkbox.checkbox-nice').addClass('checkbox-under');
				} else {
					$('.checkbox.checkbox-nice').removeClass('checkbox-under');
				}
			});
			$(document).ready(function() {
				var $windowWidth = $(window).width();
				if ($windowWidth >= 768) {
					$('.checkbox.checkbox-nice').addClass('checkbox-under');
				} else {
					$('.checkbox.checkbox-nice').removeClass('checkbox-under');
				}
			});
		}
	};
};

module.directive('chekboxLayout', [ '$timeout', chekboxLayout ]);